import { render, staticRenderFns } from "./FlightSetup.vue?vue&type=template&id=7115a50f"
import script from "./FlightSetup.vue?vue&type=script&lang=js"
export * from "./FlightSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports